import { NAV_ITEMS, pathToNavTab, isNavItemVisible } from './nav';
import styles from './MobileNav.module.css';

interface MobileNavProps {
  pathname: string;
  counts?: { needs_review?: number };
  onNavigate: (route: string) => void;
}

export function MobileNav({ pathname, counts, onNavigate }: MobileNavProps) {
  const activeTab = pathToNavTab(pathname);
  const items = NAV_ITEMS.filter(
    (item) => !item.hideInBar && isNavItemVisible(item, counts, pathname),
  );

  return (
    <nav className={styles.nav} aria-label="Primary">
      {items.map(({ id, label, Icon, route }) => (
        <button
          key={id}
          className={`${styles.tab} ${activeTab === id ? styles.active : ''}`}
          aria-current={activeTab === id ? 'page' : undefined}
          onClick={() => onNavigate(route)}
        >
          <span className={styles.icon}>
            <Icon size={20} />
            {id === 'review' && counts?.needs_review ? (
              <span
                className={styles.badge}
                aria-label={`${counts.needs_review} awaiting review`}
              >
                {counts.needs_review}
              </span>
            ) : null}
          </span>
          <span className={styles.label}>{label}</span>
        </button>
      ))}
    </nav>
  );
}
